import React from 'react';
import {
	Box,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { InternalFormValues } from './types';
import BasicInformationStep from './BasicInformationStep';
import WorkPersonalPreferencesStep from './WorkPersonalPreferencesStep';
import TravelInformationStep from './TravelInformationStep';

interface ReviewStepProps {
	formValues: InternalFormValues;
	setValue: any;
	control: any;
	errors: any;
}

export default function ReviewStep({
	formValues,
	setValue,
	control,
	errors,
}: ReviewStepProps) {
	return (
		<Box sx={{ py: 2 }}>
			{/* Basic Information */}
			<Accordion
				defaultExpanded
				sx={{
					mb: 2,
					backgroundColor: '#2F2F2F',
					boxShadow: 'none',
					borderRadius: '8px',
					'&:before': {
						display: 'none',
					},
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					sx={{
						backgroundColor: '#2F2F2F',
						'& .MuiAccordionSummary-content': {
							margin: '12px 0',
						},
						borderTopLeftRadius: '8px',
						borderTopRightRadius: '8px',
					}}
				>
					<Typography variant="h6" sx={{ color: 'text.label' }}>
						Basic Information
					</Typography>
				</AccordionSummary>
				<AccordionDetails
					sx={{
						backgroundColor: '#2F2F2F',
						borderBottomLeftRadius: '8px',
						borderBottomRightRadius: '8px',
					}}
				>
					<BasicInformationStep
						formValues={formValues}
						setValue={setValue}
						control={control}
						errors={errors}
					/>
				</AccordionDetails>
			</Accordion>

			{/* Preferences */}
			<Accordion
				sx={{
					mb: 2,
					backgroundColor: '#2F2F2F',
					boxShadow: 'none',
					borderRadius: '8px',
					'&:before': {
						display: 'none',
					},
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					sx={{
						backgroundColor: '#2F2F2F',
						'& .MuiAccordionSummary-content': {
							margin: '12px 0',
						},
						borderTopLeftRadius: '8px',
						borderTopRightRadius: '8px',
					}}
				>
					<Typography variant="h6" sx={{ color: 'text.label' }}>
						Preferences
					</Typography>
				</AccordionSummary>
				<AccordionDetails
					sx={{
						backgroundColor: '#2F2F2F',
						borderBottomLeftRadius: '8px',
						borderBottomRightRadius: '8px',
					}}
				>
					<WorkPersonalPreferencesStep
						formValues={formValues}
						setValue={setValue}
						control={control}
						errors={errors}
					/>
				</AccordionDetails>
			</Accordion>

			{/* Travel Information */}
			<Accordion
				sx={{
					mb: 2,
					backgroundColor: '#2F2F2F',
					boxShadow: 'none',
					borderRadius: '8px',
					'&:before': {
						display: 'none',
					},
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					sx={{
						backgroundColor: '#2F2F2F',
						'& .MuiAccordionSummary-content': {
							margin: '12px 0',
						},
						borderTopLeftRadius: '8px',
						borderTopRightRadius: '8px',
					}}
				>
					<Typography variant="h6" sx={{ color: 'text.label' }}>
						Travel Information
					</Typography>
				</AccordionSummary>
				<AccordionDetails
					sx={{
						backgroundColor: '#2F2F2F',
						borderBottomLeftRadius: '8px',
						borderBottomRightRadius: '8px',
					}}
				>
					<TravelInformationStep
						formValues={formValues}
						setValue={setValue}
						control={control}
						errors={errors}
					/>
				</AccordionDetails>
			</Accordion>
		</Box>
	);
}
